import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Printer } from "lucide-react";
import { api } from "@/lib/api";

const fechaHora = (iso) => new Date(iso).toLocaleString("es-ES", { dateStyle: "long", timeStyle: "short" });
const val = (v) => (v === true ? "Sí, acepta" : v || "—");

export default function ConsentimientoVer() {
  const { id } = useParams();
  const [c, setC] = useState(null);
  useEffect(() => {
    api.get(`/consentimientos/${id}`).then((r) => setC(r.data));
  }, [id]);
  if (!c) return <div className="p-8 text-slate-400">Cargando…</div>;
  if (c.pdf_base64) return <iframe title="Consentimiento" src={`data:application/pdf;base64,${c.pdf_base64}`} className="h-screen w-full" data-testid="consent-pdf-view" />;
  return (
    <div className="bg-white min-h-screen" data-testid="consent-view">
      <div className="mx-auto max-w-[800px] p-8 text-sm">
        <div className="no-print mb-4 flex justify-end"><button onClick={() => window.print()} data-testid="consent-print-btn" className="inline-flex items-center gap-2 rounded-md bg-[#1E3A8A] px-4 py-2 text-white"><Printer className="h-4 w-4" />Imprimir / PDF</button></div>
        <div className="flex items-end gap-4 border-b border-slate-300 pb-3"><img src="/logo-sv.jpg" alt="Salud y Visión" className="h-16" />
          <div><h1 className="font-[Outfit] text-xl font-bold">{c.seccion.title}</h1><div className="text-xs text-slate-600">{c.patient?.nombre}{c.patient?.codigo ? ` · ${c.patient.codigo}` : ""} · firmado en el centro el {fechaHora(c.fecha)}</div></div></div>
        {c.seccion.fields.map((f) => f.type === "legal_notice"
          ? <div key={f.id} className="mt-4 break-inside-avoid"><div className="font-semibold">{f.title}</div><p className="mt-1 text-[11px] leading-relaxed whitespace-pre-line text-justify">{f.body}</p></div>
          : <div key={f.id} className="flex gap-2 border-b border-slate-100 py-1 text-xs"><span className="w-1/2 shrink-0 text-slate-500">{f.label}</span><b>{val(c.respuestas[f.id])}</b></div>)}
        <div className="mt-6 grid grid-cols-2 gap-6 break-inside-avoid">
          <div><div className="text-xs text-slate-500">Firma firmante 1 · {c.respuestas.firmante_nombre} · {c.respuestas.firmante_dni}</div><img src={c.firma_png} alt="Firma 1" className="mt-1 h-32 border-b border-slate-400" data-testid="consent-firma-1" /></div>
          {c.firma_2_png && <div><div className="text-xs text-slate-500">Firma firmante 2 · {c.respuestas.firmante_2_nombre} · {c.respuestas.firmante_2_dni}</div><img src={c.firma_2_png} alt="Firma 2" className="mt-1 h-32 border-b border-slate-400" /></div>}
        </div>
      </div>
    </div>
  );
}
